// @todo: Migrate to 'TextField' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {TextField} from '@wandb/weave/components/Form/TextField';
import {debounce} from 'lodash';
import React, {useEffect, useMemo, useRef, useState} from 'react';
import {twMerge} from 'tailwind-merge';

export const NumberInput = ({
  className,
  placeholder,
  value,
  updateSetting,
  disabled,
}: {
  className?: string;
  placeholder: string;
  value: number | undefined;
  disabled?: boolean;
  updateSetting: (newVal?: number) => void;
}) => {
  const debouncedUpdateSetting = useMemo(
    () => debounce(updateSetting, 300),
    [updateSetting]
  );

  const [inputStr, setInputStr] = useState(getStrValue(value));

  const focusedRef = useRef(false);
  useEffect(() => {
    if (!focusedRef.current) {
      focusedRef.current = true;
      setInputStr(getStrValue(value));
    }
  }, [value]);

  return (
    <div className={twMerge('w-[5rem]', className)}>
      <TextField
        type="number"
        placeholder={placeholder}
        value={inputStr}
        disabled={disabled ?? false}
        onBlur={() => {
          focusedRef.current = false;
          setInputStr(getStrValue(value));
        }}
        onChange={(newValStr: string) => {
          setInputStr(newValStr);

          const newVal: number | undefined = parseFloat(newValStr);
          debouncedUpdateSetting(Number.isNaN(newVal) ? undefined : newVal);
        }}
      />
    </div>
  );
};

const getStrValue = (val: number | undefined) => {
  return val == null ? '' : val.toString();
};
